/**
 * Focus Theme - License Verification
 * Vérifie la clé de licence en comparant le HMAC-SHA256 du domaine Shopify
 * Se relance automatiquement quand la clé change (customizer Shopify)
 */

(function () {
  'use strict';

  var S = [70,111,99,117,115,84,104,101,109,101,50,48,50,53,83,101,99,114,101,116,75,101,121,33,64,35];

  function _k() {
    return String.fromCharCode.apply(null, S);
  }

  async function _hmac(domain) {
    var enc = new TextEncoder();
    var key = await crypto.subtle.importKey(
      'raw',
      enc.encode(_k()),
      { name: 'HMAC', hash: 'SHA-256' },
      false,
      ['sign']
    );
    var sig = await crypto.subtle.sign('HMAC', key, enc.encode(domain));
    return Array.from(new Uint8Array(sig))
      .map(function (b) { return b.toString(16).padStart(2, '0'); })
      .join('');
  }

  function _block() {
    if (document.getElementById('fs-license-overlay')) return;

    var overlay = document.createElement('div');
    overlay.id = 'fs-license-overlay';
    overlay.style.cssText =
      'position:fixed;top:0;left:0;width:100%;height:100%;z-index:999999;' +
      'background:rgba(0,0,0,0.92);display:flex;align-items:center;justify-content:center;' +
      'font-family:system-ui,-apple-system,sans-serif;transition:opacity 0.4s;';

    var box = document.createElement('div');
    box.style.cssText =
      'background:#fff;border-radius:16px;padding:48px;max-width:460px;width:90%;text-align:center;';

    box.innerHTML =
      '<div style="font-size:48px;margin-bottom:16px;">🔒</div>' +
      '<h2 style="font-size:22px;color:#111;margin:0 0 12px;">Licence requise</h2>' +
      '<p style="font-size:15px;color:#666;line-height:1.6;margin:0 0 24px;">' +
      'Ce thème nécessite une clé de licence valide pour fonctionner. ' +
      'Rendez-vous dans <strong>Paramètres du thème → Licence</strong> pour entrer votre clé.' +
      '</p>' +
      '<p style="font-size:12px;color:#aaa;margin:0;">Focus Theme by FullStack</p>';

    overlay.appendChild(box);
    document.body.appendChild(overlay);
    document.body.style.overflow = 'hidden';
  }

  function _unblock() {
    var overlay = document.getElementById('fs-license-overlay');
    if (!overlay) return;

    overlay.style.opacity = '0';
    setTimeout(function () {
      if (overlay.parentNode) overlay.parentNode.removeChild(overlay);
      document.body.style.overflow = '';
    }, 400);
  }

  async function verify() {
    var licenseEl = document.querySelector('[data-fs-license]');
    if (!licenseEl) { _block(); return; }

    var licenseKey = (licenseEl.getAttribute('data-fs-license') || '').trim().toLowerCase();
    var domain = (window.Shopify && window.Shopify.shop) ? window.Shopify.shop.toLowerCase() : '';

    if (!licenseKey || !domain) { _block(); return; }

    try {
      var expected = await _hmac(domain);
      if (licenseKey === expected) {
        _unblock();
      } else {
        _block();
      }
    } catch (e) {
      console.warn('License check: crypto not available');
    }
  }

  // Vérifier au chargement
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    verify();

    // Observer les changements sur data-fs-license (customizer Shopify met à jour l'attribut en live)
    var licenseEl = document.querySelector('[data-fs-license]');
    if (licenseEl) {
      var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].attributeName === 'data-fs-license') {
            verify();
            return;
          }
        }
      });
      observer.observe(licenseEl, { attributes: true });
    }

    // Observer aussi si le DOM est remplacé (Shopify re-render les sections)
    var bodyObserver = new MutationObserver(function () {
      var el = document.querySelector('[data-fs-license]');
      if (el) verify();
    });
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }
})();
